module.exports = __webpack_public_path__ + "b950d62287c2fe9fd96358344614a637.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/thaipbs.png
// module id = 315
// module chunks = 47